import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { authWithToken } from '../redux/feature/userSlice';

function LoginWithToken() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get('token');
  const dispatch = useDispatch();

  const handleLogin = (authData) => {    
    localStorage.clear();
    localStorage.setItem('user', JSON.stringify({ userid: authData?.userid }));
    localStorage.setItem('token', authData?.token);
    window.location.href = '/';
  };

  useEffect(() => {
    dispatch(
      authWithToken({
        token,
        successCb: (authData) => {
          handleLogin(authData);
        },
        failureCb: () => {
          window.location.href = '/';
        }
      })
    );
  }, [token]);

  return <></>;
}

export default LoginWithToken;
